module.exports = __webpack_public_path__ + "img/icon_12.5b8d2547.png";